export default [
    {
        path: 'licencias-connect-vts',
        name: 'licencias-connect-vts',
        component: () => import('./views/ConnectVtsLicensesView.vue'),
        meta: {
            requiresAuth: true,
            title: 'Licencias Connect VTS',
            roles: ['COMPANY']
        },
    }
]
